import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

const TrackingInit = () => {
  const [query] = useSearchParams();

  useEffect(() => {
    const utm_source = query.get('utm_source');

    if (utm_source) {
      sessionStorage.setItem('utm_source', utm_source);
    }
  }, [query]);

  return <></>;
};

export default TrackingInit;
